(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ConversationCustom', ConversationCustom);

    ConversationCustom.$inject = ['$resource'];

    function ConversationCustom($resource) {


        var getConversationByCurrentCompany = function () {

            var resourceUrl = 'api/get-conversation-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var setConversationMessageSeenBySupplier = function () {

            var resourceUrl = 'api/set-seen-by-supplier';
            return $resource(resourceUrl, {}, {}
            );
        };


        return {
            getConversationByCurrentCompany: getConversationByCurrentCompany,
            setConversationMessageSeenBySupplier: setConversationMessageSeenBySupplier

        };
    }
})();
